import { Typography } from 'opensolar-ui'

export default {
  list: { lazy: () => import('./ComponentContent'), component: 'ComponentContentList' },
  edit: { lazy: () => import('./ComponentContent'), component: 'ComponentContentEdit' },
  create: { lazy: () => import('./ComponentContent'), component: 'ComponentContentCreate' },
  options: {
    create: {
      title: <Typography textVariant="h5SemiBold">Create Showcase Content</Typography>,
      subtitle: null,
      breadCrumb: 'Create Showcase Content',
    },
    list: {
      title: <Typography textVariant="h5SemiBold">Showcase Content</Typography>,
      subtitle: null,
      breadCrumb: 'Showcase Content',
    },
    edit: {
      title: <Typography textVariant="h5SemiBold">Edit Showcase Content</Typography>,
      subtitle: null,
      breadCrumb: 'Edit Showcase Content',
    },
  },
}
